import { render, staticRenderFns } from "./ScheduleCalendarMobileItem.vue?vue&type=template&id=b4a3cc10&"
import script from "./ScheduleCalendarMobileItem.vue?vue&type=script&lang=js&"
export * from "./ScheduleCalendarMobileItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Button/index.vue').default})
